// extracted by mini-css-extract-plugin
export default {"brand":"Brand_brand__bOtLp","brandLogo":"Brand_brandLogo__ysbY4","brandName":"Brand_brandName__jy+Oy"};